 <template>
  <div id="app">
    <Header></Header>
    <login></login>
    <router-view />
    <Footer></Footer>
    <player></player>
  </div>
</template>
<script>
import Header from '@/components/Header'  
import Footer from '@/components/Footer'
import Player from '@/components/Player'
import Login from '@/components/Login.vue' 
import {getCookie} from '@/network/cookie'
export default { 
  data(){
    return{
      i : 0
    }
  },
  components: {
    Header,
    Footer,
    Player,
    Login
  },
  mounted(){
    window.addEventListener('scroll', this.handleScroll, true);// 监听（绑定）滚轮 滚动事件
    //首次加载如果有cookie就获取用户信息存在store里
    if(getCookie('sessionId')){
      this.$http.get({url:'xcx/user-info?sessionId='+getCookie('sessionId')}).then(res=>{
        this.$store.commit('updateUserInfo',res.data.data);
      })
    }
  },
  methods:{
         handleScroll(){
            // 页面滚动距顶部距离
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 
                      document.body.scrollTop
            var scroll = scrollTop - this.i;
            this.i = scrollTop;
            if(scroll<=0){
                 document.getElementById('header').style.position = 'fixed';
                 document.getElementById('topheight').style.height = '80px';
             }else{
                 document.getElementById('header').style.position = 'relative';
                 document.getElementById('topheight').style.height = '0px';
            }
        }
    },
    created(){
        this.$nextTick(() => {
        // 禁用右键
        document.oncontextmenu = new Function("event.returnValue=false");
        // 禁用选择
        document.onselectstart = new Function("event.returnValue=false");
      });
    },
  
}
</script>
<style>
body{margin: 0;}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; 
  color: #2c3e50;  
}
.container{width: 1100px; margin: 0 auto; overflow: hidden; }
 
.slider-btn-left,.slider-btn-right{background:none !important;}
.height30{height: 30px;}
input,button{outline: none;}
</style>
